// Routes du module « mémoire technique » : dans le dossier d'étude, après le devis. Rien n'est ajouté à la barre de navigation.
import type { RouteObject } from 'react-router';
import '../../styles/memoire.css';
import { PageMemoires } from './PageMemoires.tsx';
import { PageMemoire } from './PageMemoire.tsx';

export const routesMemoire: RouteObject[] = [
  { path: 'etudes/:id/memoire', element: <PageMemoires /> },
  { path: 'etudes/:id/memoires/:mid', element: <PageMemoire /> },
];
